/* eslint-disable no-nested-ternary */
import { SHARED_ROUTES } from '@aibees/shared/constants';
import { PlanInterval } from '@aibees/shared/definition';
import { useCurrentPlanInfo } from '@aibees/shared/features/price-and-plan/hooks/use-current-plan-info';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SubscriptionInfoCardProps as Props } from './types';

export const SubscriptionInfoCard = memo(
  ({
    className,
    isCurrent,
    title,
    interval,
    amount,
    isFree,
    startDate,
  }: Props) => {
    const { lowOnCredit, ranOutOfCredit } = useCurrentPlanInfo();

    const sxProps = {
      isCurrent,
      isLow: isCurrent && lowOnCredit,
      isRanOut: isCurrent && ranOutOfCredit,
    };

    return (
      <Styled.Wrapper
        className={classnames('SubscriptionInfoCard', className)}
        sx={SX.root(sxProps)}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack>
          <Typography variant="body4" fontWeight={400} sx={SX.title(sxProps)}>
            {isCurrent ? title : `Effective on ${startDate}`}
          </Typography>
          <Typography variant="body4" fontWeight={700} sx={SX.amount(sxProps)}>
            {amount} /{' '}
            {isFree
              ? 'Free Plan'
              : interval === PlanInterval.MONTH
              ? 'Monthly'
              : 'Yearly'}
          </Typography>
        </Stack>
        {isCurrent ? (
          <Styled.UpdradeLink
            to={SHARED_ROUTES.priceAndPlan}
            className={classnames({
              isLow: isCurrent && lowOnCredit,
              isRanOut: isCurrent && ranOutOfCredit,
            })}
          >
            <Typography
              variant="body4"
              color={
                ranOutOfCredit
                  ? 'error.500'
                  : lowOnCredit
                  ? 'warning.500'
                  : 'primary.500'
              }
            >
              🚀 Upgrade
            </Typography>
          </Styled.UpdradeLink>
        ) : (
          <Typography variant="body4" sx={SX.amount(sxProps)}>
            Upcoming Plan
          </Typography>
        )}
      </Styled.Wrapper>
    );
  }
);

SubscriptionInfoCard.displayName = 'SubscriptionInfoCard';
